/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 11:15:14
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-06-30 16:09:24
 * @Description: api入口
 * @FilePath: /hsylc2021/src/api/index.js
 */
export { default as Api } from './factory';
export { default as Codes } from './codes';
export { default as GETS } from './apis.get';
export { default as POSTS } from './apis.post';
export { default as DELETES } from './apis.delete';
export { default as checker } from './checker';
